module.exports = ":host .ticket-quota-messages__headlines {\n  font-size: 0.85em;\n  font-weight: bold;\n  margin-bottom: 1em; }\n\n:host .ticket-quota-message {\n  margin-top: 0.5em; }\n  @media (max-width: 992px) {\n    :host .ticket-quota-message .ticket-quota-message__input {\n      margin-bottom: 0; } }\n\n:host .ticket-quota-message__comment {\n  margin: 1em 0 2em 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/event-components/ticket-quota-collection/ticket-quota-message-editor/ticket-quota-message-editor.scss
// module id = i/8u
// module chunks = 12